module.exports = __webpack_public_path__ + "check-marked.svg";